import React from "react";

function FieldNoteHeader({ fieldNote }) {
  return (
    <div className="pd-header fieldnote-header">
      <div className="header-bottom">
        <h2 className="pd-title has-bg-image">{fieldNote.title}</h2>
        <p className="fieldnote-author-line has-bg-image">by {fieldNote.name}</p>
      </div>
    </div>
  );
}

export default FieldNoteHeader;
